export default {"src":"/_next/static/media/whiteboard.3d51f2d4.svg","height":115,"width":150,"blurWidth":0,"blurHeight":0};